module.exports = __webpack_public_path__ + "static/media/200.f414e5af.svg";